import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Page from '../index'
import AdsSection from './AdsSection'
import PageSectionHeader from '../../features/components/PageSectionHeader'
import Tabs from '../../features/components/Tabs'

import { getAvailablePlatformList } from '../../helpers/handlePlatformSelection'

import { setSelectedPlatform } from '../../modules/actions/app'

import {
  selectedDV360AdAccountSelector,
  selectedFacebookAdAccountSelector,
  selectedGoogleAdAccountSelector,
  selectedTikTokAdAccountSelector
} from '../../modules/selectors/adAccounts'
import { selectedPlatformSelector } from '../../modules/selectors/app'
import { selectedPartnershipSelector } from '../../modules/selectors/partnerships'

import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../constants/selectLists/platformList'

import useStyles from './styles'

function AdApprovalsPage() {
  const classes = useStyles()
  const dispatch = useDispatch()

  const selectedPlatform = useSelector(selectedPlatformSelector)
  const { id: facebookAdAccountId } = useSelector(selectedFacebookAdAccountSelector)
  const { id: googleAdAccountId } = useSelector(selectedGoogleAdAccountSelector)
  const { id: dv360AdAccountId } = useSelector(selectedDV360AdAccountSelector)
  const { id: tikTokAdAccountId } = useSelector(selectedTikTokAdAccountSelector)
  const { providers: availableProviders } = useSelector(selectedPartnershipSelector)

  const showSection = useMemo(
    () => ({
      [FACEBOOK_PLATFORM]: !!facebookAdAccountId && selectedPlatform === FACEBOOK_PLATFORM,
      [GOOGLE_PLATFORM]: !!googleAdAccountId && selectedPlatform === GOOGLE_PLATFORM,
      [DV_360_PLATFORM]: !!dv360AdAccountId && selectedPlatform === DV_360_PLATFORM,
      [TIKTOK_PLATFORM]: !!tikTokAdAccountId && selectedPlatform === TIKTOK_PLATFORM
    }),
    [facebookAdAccountId, selectedPlatform, googleAdAccountId, dv360AdAccountId, tikTokAdAccountId]
  )

  // don't show platform which user don't have access to
  const availablePlatformList = useMemo(() => getAvailablePlatformList(availableProviders), [availableProviders])

  const PlatformTabs = useMemo(
    () => (
      <Tabs
        options={availablePlatformList}
        selectedValue={selectedPlatform}
        onSelectValue={value => dispatch(setSelectedPlatform(value))}
      />
    ),
    [dispatch, availablePlatformList, selectedPlatform]
  )

  return (
    <Page helmetTitle="Ad Approvals" className={classes.page}>
      <PageSectionHeader
        title="Ad Approvals"
        // show platform tabs selector when more then 1 platform available
        RightPanel={availablePlatformList.length > 1 && PlatformTabs}
      />
      <AdsSection showSection={showSection} />
    </Page>
  )
}

export default AdApprovalsPage
